export const statusMap = new Map([
  [1, { label: 'In Progress', class: 'inProgress' }],
  [2, { label: 'In Progress', class: 'inProgress' }],
  [3, { label: 'In Progress', class: 'inProgress' }],
  [4, { label: 'Completed', class: 'success' }],
  [5, { label: 'Error', class: 'warning' }],
  [6, { label: 'Shared', class: 'shared' }]
])
